// extracted by mini-css-extract-plugin
export default {"soloButton":"Button_soloButton__39nAj","defaultButton":"Button_defaultButton__+t3Jy"};